// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/fonts/basiercircle-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/fonts/basiercircle-semibold-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/fonts/Sansation_Bold_Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/fonts/Sansation_Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/fonts/Sansation_Light_Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/fonts/Sansation_Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/src/fonts/Sansation_Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/src/fonts/Sansation_Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/src/fonts/BwGradual-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/src/fonts/BwGradual-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/src/fonts/BwGradual-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("/src/fonts/BwGradual-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("/src/fonts/BwGradual-Light.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Basier Circle";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  font-weight: normal;
  font-display: swap;
}

@font-face {
  font-family: "Basier Circle";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-weight: 600;
  font-display: swap;
}

@font-face {
  font-family: "Sansation";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-display: swap;
  font-style: italic;
  font-weight: bold;
}

@font-face {
  font-family: "Sansation";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-display: swap;
  font-style: italic;
  font-weight: normal;
}

@font-face {
  font-family: "Sansation";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-display: swap;
  font-style: italic;
  font-weight: lighter;
}

@font-face {
  font-family: "Sansation";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-display: swap;
  font-style: normal;
  font-weight: lighter;
}

@font-face {
  font-family: "Sansation";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
  font-display: swap;
  font-style: normal;
  font-weight: bold;
}

@font-face {
  font-family: "Sansation";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
  font-display: swap;
  font-style: normal;
  font-stretch: normal;
}

@font-face {
  font-family: "Bw Gradual";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2");
  font-display: swap;
  font-weight: normal;
}

@font-face {
  font-family: "Bw Gradual";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff2");
  font-display: swap;
  font-weight: bold;
}

@font-face {
  font-family: "Bw Gradual";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2");
  font-display: swap;
  font-weight: 900;
}

@font-face {
  font-family: "Bw Gradual";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff2");
  font-display: swap;
  font-weight: 600;
}

@font-face {
  font-family: "Bw Gradual";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2");
  font-display: swap;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/styles/fonts.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,4DAAyE;EACzE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,4DAA0E;EAC1E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAAmE;EACnE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,+DAA8D;EAC9D,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,+DAAoE;EACpE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,+DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,+DAA4D;EAC5D,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,+DAA+D;EAC/D,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,4DAA8D;EAC9D,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,4DAA2D;EAC3D,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,6DAAgE;EAChE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,6DAA4D;EAC5D,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: \"Basier Circle\";\n  src: url('/src/fonts/basiercircle-regular-webfont.woff2') format(\"woff2\");\n  font-weight: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Basier Circle\";\n  src: url('/src/fonts/basiercircle-semibold-webfont.woff2') format(\"woff2\");\n  font-weight: 600;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Sansation\";\n  src: url(\"/src/fonts/Sansation_Bold_Italic.ttf\") format(\"truetype\");\n  font-display: swap;\n  font-style: italic;\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"Sansation\";\n  src: url(\"/src/fonts/Sansation_Italic.ttf\") format(\"truetype\");\n  font-display: swap;\n  font-style: italic;\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: \"Sansation\";\n  src: url(\"/src/fonts/Sansation_Light_Italic.ttf\") format(\"truetype\");\n  font-display: swap;\n  font-style: italic;\n  font-weight: lighter;\n}\n\n@font-face {\n  font-family: \"Sansation\";\n  src: url(\"/src/fonts/Sansation_Light.ttf\") format(\"truetype\");\n  font-display: swap;\n  font-style: normal;\n  font-weight: lighter;\n}\n\n@font-face {\n  font-family: \"Sansation\";\n  src: url(\"/src/fonts/Sansation_Bold.ttf\") format(\"truetype\");\n  font-display: swap;\n  font-style: normal;\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"Sansation\";\n  src: url(\"/src/fonts/Sansation_Regular.ttf\") format(\"truetype\");\n  font-display: swap;\n  font-style: normal;\n  font-stretch: normal;\n}\n\n@font-face {\n  font-family: \"Bw Gradual\";\n  src: url('/src/fonts/BwGradual-Regular.woff2') format(\"woff2\");\n  font-display: swap;\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: \"Bw Gradual\";\n  src: url('/src/fonts/BwGradual-Bold.woff2') format(\"woff2\");\n  font-display: swap;\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"Bw Gradual\";\n  src: url('/src/fonts/BwGradual-ExtraBold.woff2') format(\"woff2\");\n  font-display: swap;\n  font-weight: 900;\n}\n\n@font-face {\n  font-family: \"Bw Gradual\";\n  src: url('/src/fonts/BwGradual-Medium.woff2') format(\"woff2\");\n  font-display: swap;\n  font-weight: 600;\n}\n\n@font-face {\n  font-family: \"Bw Gradual\";\n  src: url('/src/fonts/BwGradual-Light.woff2') format(\"woff2\");\n  font-display: swap;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
